module.exports = __webpack_public_path__ + "img/vdb_logo.cf1c0079.png";